<template>
  <div
    :id="id"
    class="editorial-list"
    :class="divClass"
    :style="{marginTop: removeTopGap ? '-60px' : ''}"
    v-bind="wrapperAttributes"
  >
    <template v-if="shouldShowAccordion">
      <pdl-collapse :default-active="false" :header-level="listHeaderLevel">
        <pdl-collapse-item :name="title">
          <template #title>
            {{ title }}
          </template>
          <component :is="listTag">
            <slot name="list-items"></slot>
          </component>
        </pdl-collapse-item>
      </pdl-collapse>
    </template>
    <template v-else>
      <component :is="headingTag" v-if="title || headingLink" class="list-heading">
        <template v-if="headingLink && title">
          <a :href="headingUrl" class="headingLinked">
            <span :class="headingClass" v-html="title" />
          </a>
          <span :class="`headingUnlinked ${headingClass}`" v-html="title" />
        </template>
        <template v-else-if="headingLink && isTitleEmpty">
          <slot name="heading-slot"></slot>
        </template>
        <template v-else>
          <span :class="headingClass" v-html="title" />
        </template>
      </component>
      <component :is="listTag">
        <slot name="list-items"></slot>
      </component>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';

export default {
  name: 'TrekListComponent',
  components: {PdlCollapse, PdlCollapseItem},
  props: {
    id: {
      type: String,
      required: true,
    },
    divClass: {
      type: String,
      default: '',
    },
    headingTag: {
      type: String,
      required: true,
    },
    removeTopGap: {
      type: Boolean,
      required: true,
    },
    listTag: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    wrapperTagAttr: {
      type: String,
      required: true,
    },
    headingLink: {
      type: Boolean,
    },
    headingUrl: {
      type: String,
      required: true,
    },
    headingClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('viewSize', ['viewBreakpointLessThan']),
    isTitleEmpty() {
      return this.title === '';
    },
    listHeaderLevel() {
      return this.headingTag?.split('h')[1];
    },
    isExplodingAccordion() {
      return this.wrapperTagAttr === 'data-accordion-explode';
    },
    shouldShowAccordion() {
      return this.viewBreakpointLessThan('medium') && this.isExplodingAccordion;
    },
    containerStyle() {
      return this.removeTopGap ? {marginTop: '-60px'} : {};
    },
    wrapperAttributes() {
      if (this.shouldShowAccordion || !this.wrapperTagAttr) {
        return {};
      }
      return {[this.wrapperTagAttr]: true};
    },
  },
};
</script>

<style scoped>
:deep(.pdl-collapse-item__header) {
  background-color: transparent;
  font-weight: 700;
  padding: 1rem 0;
  color: var(--gray-02);
  border-color: var(--gray-80);
  text-transform: uppercase;
  font-size: 0.875rem;
}

:deep(.pdl-collapse-item__wrap) {
  border-color: var(--gray-80);
  background-color: transparent;

  .list-item a:focus-visible {
    outline: 0.125rem solid var(--blue-100);
    outline-offset: 0.125rem;
  }
}

:deep(.pdl-collapse-item__content) {
  color: var(--gray-80);
}
</style>
